import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { AppUpdateScreen } from './features/shell/AppUpdateScreen';
import { unlockAudioOnGesture } from './lib/notifications';
import { debugPeers, relayReport, useVoice } from './lib/voice';
import { useStore } from './store/store';
import './styles.css';

if (import.meta.env.DEV) {
  // Debug handle for development only; stripped from production builds.
  (window as unknown as { __spawnwire: unknown }).__spawnwire = { store: useStore, voice: useVoice, peers: debugPeers, relay: relayReport };
}

unlockAudioOnGesture();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* Android app only: over everything, signed in or not. */}
      {__NATIVE__ && <AppUpdateScreen />}
    </BrowserRouter>
  </StrictMode>,
);
